module.exports = __webpack_public_path__ + "static/media/Specialized-Nutrition.87ea6797.png";